/**
 * Calculates the total number of available checks based on the tariff & period.
 * This functions applies only to productId = 7 (DB API), for other products it will return 0.
 *
 * @param product
 * @return {number}
 */
export default (product) => {
    const productId = product?.product_id;
    if (productId !== 2 || !product?.tariff || !product.period) {
        return 0;
    }
    return Math.round((product.tariff?.checks ?? 0) * (product.period?.interval ?? 0) + (
        product?.bonus_unit === 'checks' ? product?.bonus_amount : 0
    ));
}
